import Styled from "styled-components";

export const Footer = Styled.div`
  position: relative;
  bottom: 0;
`;
